const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M12.5255 3.47452C12.5255 3.47452 7.45097 8.54903 3.47452 12.5255M12.5255 12.5255C12.5255 12.5255 7.89279 7.8928 3.47452 3.47452"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export { CloseIcon };
